import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import { PRODUCTS_QUERY_CACHE_EXPIRE_TIME_MS } from "../../config/constansts";
import { ProductResults, ProductsQueryParams } from "@core/types";
import { productsClient } from "@core/clients";

const useGetFeaturedProductsQuery = (productsQueryParams: ProductsQueryParams, options: UseQueryOptions<ProductResults> = {}) => {
  return useQuery<ProductResults, any>(
    ["products", "featured"],
    async () => {
      return await productsClient.getFeaturedProducts(productsQueryParams);
    },
    {
      cacheTime: PRODUCTS_QUERY_CACHE_EXPIRE_TIME_MS,
      staleTime: PRODUCTS_QUERY_CACHE_EXPIRE_TIME_MS,
      ...options,
    }
  );
};

export default useGetFeaturedProductsQuery;
